import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { deleteOne, getOne, update } from '../common/BackendProvider';
import { toast, ToastContainer } from "react-toastify";
import Button from '../layout/components/Button';
import { InvestmentProfileForm, normaliseProfile } from "./investmentProfiles/InvestmentProfileForm";

export const InvestmentProfilesEdit = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        getOne("investment-profiles", { id }).then((response) => {
            setProfile(normaliseProfile(response.data.profile || {}));
            setLoading(false);
        }).catch(() => {
            toast.error("Error while loading investment profile", {});
            setLoading(false);
        });
    }, [id]);

    const handleSave = () => {
        setSaving(true);
        update("investment-profiles", { id, data: profile }).then((response) => {
            setProfile(normaliseProfile(response.data.profile || profile));
            toast.success("Profile saved successfully", {});
        }).catch((error) => {
            toast.error(error.message, {});
        }).finally(() => {
            setSaving(false);
        });
    };

    const handleDelete = () => {
        deleteOne("investment-profiles", { id }).then(() => {
            toast.success("Profile deleted successfully", {});
            navigate(`/investment_profiles`);
        }).catch((error) => {
            toast.error(error.message, {});
        });
    };

    return (
        <div className="space-y-5 p-4 lg:p-8">
            <ToastContainer />
            <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                <div>
                    <div className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-600">Investor mandate</div>
                    <h1 className="mt-2 text-3xl font-bold text-slate-950">
                        {loading ? "Investment Profile" : profile?.name}
                    </h1>
                    <p className="mt-2 max-w-3xl text-sm font-medium leading-6 text-slate-500">
                        Refine this profile across risk, impact intensity, impact themes, and SDG priorities.
                    </p>
                </div>
                <Button variant="danger" onClick={handleDelete}>Delete</Button>
            </div>
            {!loading && profile ? (
                <InvestmentProfileForm
                    profile={profile}
                    onChange={setProfile}
                    onSubmit={handleSave}
                    submitLabel="Save profile"
                    saving={saving}
                />
            ) : (
                <div className="rounded-lg border border-slate-200 bg-white p-8 text-sm font-semibold text-slate-500 shadow-sm">
                    Loading profile...
                </div>
            )}
        </div>
    );
};
